import React, { Fragment } from "react";
import { IconButton, Menu, MenuItem } from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import MoreHoriz from "@material-ui/icons/MoreHoriz";
import styled from "styled-components";

const StyledIconButton = styled.span`
  && {
    :hover {
      background-color: rgba(0, 0, 0, 0);
    }
    path {
      fill: #cccccc !important;
    }
    :hover path {
      fill: #999999 !important;
    }
  }
`;

class OptionsMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null
    };
  }

  handleIconButtonClick = event => {    
    this.setState({
      anchorEl: event.currentTarget
    });    
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  handleMenuItemClick = (optionId, onClick) => {
    this.setState({
      anchorEl: null      
    });
    if (onClick) onClick(optionId, this.props.row);
  };

  renderMenu(anchorEl, isMenuOpen) {
    let maxHeight = this.props.maxHeight || 216;    
    return (
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={this.handleMenuClose}
        PaperProps={{ style: { maxHeight: maxHeight, width: 250 } }}
      >
        {this.props.options.map(option => {
          if (option.isHR) {
            return <hr key={option.id} />
          } else if ( option.render ) {
            return option.render(this.props.fundId);
          } else {
            return (
              <MenuItem
                key={option.id}
                onClick={() =>
                  this.handleMenuItemClick(option.id, option.onClick)
                }
              >
                {option.value}
              </MenuItem>
            )
          }
        })}
      </Menu>
    );
  }
  defaultButtonRenderer = (isMenuOpen, iconButtonClickHandler) => {
    return (<StyledIconButton
      aria-label="More"
      aria-owns={isMenuOpen ? "long-menu" : null}
      aria-haspopup="true"
      onClick={iconButtonClickHandler}>
      {this.props.isHorizontal ? (
        <MoreHoriz />
      ) : (
          <MoreVertIcon />
        )}
    </StyledIconButton>)
  }

  render() {
    const { anchorEl } = this.state;
    const isMenuOpen = Boolean(anchorEl);
    let buttonRenderer = this.defaultButtonRenderer;
    if(this.props.buttonRenderer)
      buttonRenderer = this.props.buttonRenderer;
    return (
      <Fragment>
        {buttonRenderer(isMenuOpen, this.handleIconButtonClick)}
        {this.renderMenu(anchorEl, isMenuOpen)}
      </Fragment>
    );
  }
}

export default OptionsMenu;
